/**
 * @file 未完成案件弹窗内容组件
 * @description 案件状态为未完成（待办理/处理中）时显示，包含坐标、地址、区域标识信息
 */
<template>
    <div class="case-dialog-content-pending">
        <div class="case-name">
            {{ caseDialogObj.name }}
        </div>
        <div class="case-status" v-if="caseDialogObj.status !== undefined && caseDialogObj.status !== null">
            <span :class="['status-tag', getStatusClass(caseDialogObj.status)]">{{ caseDialogObj.statusLabel }}</span>
        </div>
        <div class="case-row">
            <span class="label">{{  $t('yingji.emergencyCase.wgs84Coordinate')  }}</span>
            <span class="value">{{ caseDialogObj.longitude + ',' + caseDialogObj.latitude }}</span>
            <span class="btn " @click="copyFn(caseDialogObj.location)">{{  $t('yingji.emergencyCase.copy')  }}</span>
        </div>
        <div class="case-row">
            <span class="label">{{  $t('yingji.emergencyCase.incidentLocation')  }}</span>
            <span class="value">{{ caseDialogObj.location }}</span>
        </div>
        <div class="case-flags">
            <div class="flag-item" :class="{ 'is-true': caseDialogObj.isForbid }">
                <i :class="caseDialogObj.isForbid ? 'el-icon-circle-check' : 'el-icon-warning-outline'"></i>
                <span>{{  (caseDialogObj.isForbid ? $t('yingji.emergencyCase.isNoFlyZoneTrue') : $t('yingji.emergencyCase.isNoFlyZoneFalse'))  }}</span>
            </div>
            <div class="flag-item" :class="{ 'is-true': caseDialogObj.isLimitHeight }">
                <i :class="caseDialogObj.isLimitHeight ? 'el-icon-circle-check' : 'el-icon-warning-outline'"></i>
                <span>{{  (caseDialogObj.isLimitHeight ? $t('yingji.emergencyCase.isHeightLimitZoneTrue') : $t('yingji.emergencyCase.isHeightLimitZoneFalse'))  }}</span>
            </div>
            <div class="flag-item" :class="{ 'is-true': caseDialogObj.isDockCover }">
                <i :class="caseDialogObj.isDockCover ? 'el-icon-circle-check' : 'el-icon-warning-outline'"></i>
                <span>{{  (caseDialogObj.isDockCover ? $t('yingji.emergencyCase.isDockCoveredTrue') : $t('yingji.emergencyCase.isDockCoveredFalse'))  }}</span>
            </div>
        </div>
        <div class="case-footer" style="justify-content: flex-end; padding-right: 10px;">
            <div class="btn delete-btn" @click="showDelDialogFn">{{  $t('yingji.emergencyCase.delete')  }}</div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'EmergencyCasePending',
    props: {
        caseDialogObj: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapGetters(['userInfo']),
    },
    methods: {
        copyFn(location) {
            this.$emit('copy', location);
        },
        showDelDialogFn() {
            this.$emit('delete');
        },
        getStatusText(status) {
            const statusMap = {
                0: this.$t('yingji.emergencyCase.pending'),
                1: this.$t('yingji.emergencyCase.processing'),
                2: this.$t('yingji.emergencyCase.done'),
            };
            return statusMap[status] || (this.$t('yingji.emergencyCase.pending'));
        },
        getStatusClass(status) {
            const classMap = {
                0: 'status-pending',
                1: 'status-processing',
                2: 'status-done',
            };
            return classMap[status] || 'status-pending';
        },
    },
};
</script>

<style lang="scss" scoped>
.case-dialog-content-pending {
    .case-name {
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        line-height: 1.4;
        margin-bottom: 10px;
        max-width: 500px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .case-status {

        .status-tag {
            display: inline-block;
            padding: 2px 12px;
            border-radius: 2px;
            font-size: 12px;
            font-weight: normal;
            color: #fff;

            &.status-pending {
                background: rgba(73, 240, 253, 0.2);
                color: #49f0fd;
            }

            &.status-processing {
                background: rgba(255, 152, 0, 0.2);
                color: #ff9800;
            }

            &.status-done {
                background: rgba(0, 255, 136, 0.2);
                color: #00ff88;
            }
        }
    }

    .case-row {
        display: flex;
        align-items: center;
        height: 40px;

        .label {
            width: 75px;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.8);
            text-align: justify;
            text-align-last: justify;
        }

        .value {
            flex: 1;
            padding-left: 20px;
            font-size: 14px;
            color: #fff;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            user-select: text;
        }

        .btn {
            flex: 0 0 auto;
            height: 25px;
            padding: 2px 8px;
            margin-left: 10px;
            font-size: 12px;
            line-height: 16px;
            background: rgba(73, 240, 253, 0.3);
            border-radius: 2px;
            border: 1px solid #49f0fd;
            color: #49f0fd;
            cursor: pointer;
            transition: all 0.2s;

            &:hover {
                background: rgba(73, 240, 253, 0.6);
            }
        }
    }

    .case-flags {
        display: flex;
        gap: 20px;
        padding: 5px 0;

        .flag-item {
            display: flex;
            align-items: center;
            gap: 5px;
            font-size: 14px;
            color: #ff9800;

            i {
                font-size: 18px;
                color: currentColor;
            }

            &.is-true {
                color: #49f0fd;
            }
        }
    }

    .case-footer {
        display: flex;
        margin-top: 8px;

        .btn {
            width: 52px;
            height: 25px;
            line-height: 22px;
            background: rgba(73, 240, 253, 0.3);
            border-radius: 2px;
            border: 1px solid #49f0fd;
            color: #fff;
            text-align: center;
            cursor: pointer;
            transition: all 0.2s;

            &:hover {
                background: rgba(73, 240, 253, 0.6);
            }
        }
    }
}
</style>
